import React from 'react';
import { Card } from './ui/card';

const FurnishedApartments = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 md:order-1">
              <img
                src="https://images.pexels.com/photos/11112253/pexels-photo-11112253.jpeg"
                alt="Möblierte Wohnung"
                className="rounded-2xl shadow-xl"
              />
            </div>

            <div className="order-1 md:order-2">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
                Auch möblierte Wohnungen möglich
              </h2>
              <p className="text-xl text-slate-600 mb-6 leading-relaxed">
                Auch möblierte Wohnungen streichen wir fachgerecht. Durch zusätzlichen Abdeck- und Schutzaufwand ist der Preis hier etwas höher. Gerne erstellen wir Ihnen auch dafür ein individuelles Fixpreis-Angebot.
              </p>

              <Card className="p-6 bg-blue-50 border-l-4 border-blue-600">
                <div className="text-lg text-slate-700">
                  <strong className="text-blue-700">Inklusive:</strong>
                  <ul className="mt-3 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">✓</span>
                      <span>Professionelles Abdecken aller Möbel und Gegenstände</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">✓</span>
                      <span>Sorgfältige Ausführung ohne Beschädigungen</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">✓</span>
                      <span>Individuelles Fixpreis-Angebot nach Besichtigung</span>
                    </li>
                  </ul>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FurnishedApartments;